export const paraCentavos = valor => {
  const numero = Number(valor) || 0;
  return Math.round((numero + Math.sign(numero) * Number.EPSILON) * 100);
};

export const arredondarMoeda = valor => paraCentavos(valor) / 100;

export const somarMoeda = (...valores) =>
  valores.reduce((total, valor) => total + paraCentavos(valor), 0) / 100;
